import * as React from 'react';
import SvgIcon from '../../SvgIcon';
const SvgVisible = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12 16.38a4.25 4.25 0 1 1 4.23-4.24A4.24 4.24 0 0 1 12 16.38M3.63 12q3.08 5.55 8.44 5.55t8.3-5.55Q17.1 6.42 12 6.42T3.63 12M0 12.05Q4.68 4 12 4t12 8.05q-4.2 8-11.9 8t-12.1-8"
    }));
export default SvgVisible;
